<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { AkAccountNav } from '@ankorstore/design-system';
import { useAccountMenu } from '@monolith/legacy/components/account/composables/use-account-menu';
import { useAccountMenuHighlight } from '@monolith/legacy/components/account/composables/use-account-menu-highlight';

const { t } = useI18n();
const { items, getCurrentUrl, navigate } = useAccountMenu(true);

const logout = () => {
  (document.getElementById('logout-form') as HTMLFormElement)?.submit();
};

const { itemsWithHighlight, isAccountRoute, handleHighlightClosed } = useAccountMenuHighlight(items, getCurrentUrl);
</script>

<template>
  <AkAccountNav
    v-if="itemsWithHighlight.length && getCurrentUrl"
    :items="itemsWithHighlight"
    :url-active="getCurrentUrl"
    :all-closed="!isAccountRoute"
    :as-link="true"
    data-testid="retailerMobileMenu"
    @navigation-clicked="navigate"
    @highlight-closed="handleHighlightClosed"
  />
  <ul>
    <li class="divider" />
    <li>
      <a
        href=""
        @click.prevent="logout"
      >{{ t('shared.menu.logout') }}</a>
    </li>
    <li class="divider" />
  </ul>
</template>
